import React, { useState, useEffect } from 'react';
import { Button, Card, Tooltip } from 'antd';

import { useNavigate, useParams } from 'react-router-dom';
import { errorCatch, GET, JSXMap, POST, useAuth, useTranslateContext } from 'fennec-ui';
import { useRef } from 'react';
import ReactToPrint from 'react-to-print';
import { PrinterOutlined } from '@ant-design/icons';
import Icofont from 'react-icofont';
import { getIndexColor, getIndexColorAlt, getIndexColorLighter } from '../../../../common/Tool';
import dayjs from 'dayjs';

const User = ({ user }) => {
	return (<div style={{
		border: "1px solid transparent",
		maxWidth: "208px",
		minWidth: "208px",
		overflow: "hidden",
		textOverflow: "ellipsis",
		whiteSpace: "nowrap",
		display: "flex",
		justifyContent: "flex-start",
		gap: "5px",
		alignItems: "center"
	}}>
		<div style={{ backgroundColor: (user?.genderID === 1) ? "blue" : "red", width: "13px", height: "13px", lineHeight: "13px", borderRadius: "3px", textAlign: "center" }}>
			<Icofont icon='user' style={{ color: "white", fontSize: "8px", marginLeft: "1px" }} />
		</div>
		<div>{user?.lastname} {user?.firstname}</div>
	</div>)
}
export default function PredvzyatostSudiEvent(props) {
	let navigate = useNavigate();

	const { auth, meropriyatieID, judgeID, dancerIdList } = props;
	const t = useTranslateContext();
	const [loading, setLoading] = useState(false);

	const [data, setData] = useState()
	// judge
	// psItogPoMeropriyatiyu
	// esOtsenkiSudey
	// notFoundDancerList

	useEffect(() => {
		setLoading(true);

		POST(auth, `/api/report/predvzyatost-sudi-po-tantsoram`, {
			meropriyatieID: meropriyatieID,
			judgeID: judgeID,
			dancerIdList: dancerIdList,
		},
			({ data }) => {
				data.tourCriterionParams = getTourCriterionParams(data?.esOtsenkiSudey)
				setData(data)
				setLoading(false);
			}, (err) => errorCatch(err, () => setLoading(false)));

	}, [auth, meropriyatieID, judgeID, dancerIdList]);

	const getTourCriterionParams = (esOtsenkiSudey) => {
		if (!esOtsenkiSudey?.length) {
			return [];
		}

		let resMap = {};
		for (let i = 0; i < esOtsenkiSudey.length; i++) {
			const el = esOtsenkiSudey[i];
			resMap[el?.parametrKriteriya?.ID] = { parametrKriteriya: el.parametrKriteriya, tour: el.tour }
		}

		let res = [];

		for (const key in resMap) {
			if (Object.hasOwnProperty.call(resMap, key)) {
				const el = resMap[key];
				res.push(el);
			}
		}

		res.sort((a, b) => {
			if (a.tour.ID > b.tour.ID) {
				return true
			} else if (a.tour.ID < b.tour.ID) {
				return false
			} else {
				return a.parametrKriteriya.ID - b.parametrKriteriya.ID
			}
		})

		return res;
	}

	const ref = useRef(null)

	return (
		<div>
			<Card loading={loading} bordered={false} bodyStyle={{ padding: "0" }} >
				{/* <div style={{ display: "flex", justifyContent: "right", padding: "15px 20px" }} >
					<ReactToPrint
						trigger={() => {
							// NOTE: could just as easily return <SomeComponent />. Do NOT pass an `onClick` prop
							// to the root node of the returned component as it will be overwritten.
							return (<Button type="ghost" style={{ color: "rgba(0, 0, 0, 0.65)", fontSize: "14px", }}><PrinterOutlined /> Печать</Button>)
						}}
						content={() => ref.current}
					/>
				</div> */}
				{(data?.tourCriterionParams) && <div className="report" ref={ref}>
					{(data?.judge) && <div style={{ display: "flex", flexDirection: "column", alignItems: "center", fontSize: "16px", marginBottom: "20px" }}>
						{/* <div>
							Судья: {data.judge?.user?.lastname} {data.judge?.user?.firstname}
						</div> */}
						<div>
							<span>{data?.judge?.meropriyatie?.nazvanieMeropriyatiya}</span> - {dayjs(data?.judge?.meropriyatie?.nachaloSorevnovaniya).format("DD.MM.YYYY")} ({data?.judge?.meropriyatie?.mestoProvedeniya?.name})
						</div>
					</div>}
					<div className='scrollable' style={{ backgroundColor: "white" }}>
						<table className="table" style={{ fontSize: "13px" }}>
							<thead>
								<tr>
									<th className={`wrap fixed`} style={{ minWidth: "210px", backgroundColor: "white" }}>
										<div className='bg bg-grey dark-1'>Участник</div>
									</th>
									<th className="wrap fixed" style={{ left: "210px", minWidth: "100px", maxWidth: "100px", backgroundColor: "white" }}>
										<div className='bg bg-orange dark-5 border-orange' style={{ fontWeight: "bold" }}>Среднее арифм.</div>
									</th>
									<th className="wrap fixed" style={{ left: "310px", minWidth: "100px", maxWidth: "100px", backgroundColor: "white" }}>
										<div className='bg bg-orange dark-5 border-orange' style={{ fontWeight: "bold" }}>Среднее по дисперсиям</div>
									</th>
									{JSXMap(data?.tourCriterionParams, (tourCriterion, cidx) => {
										let color = getIndexColorLighter(tourCriterion?.parametrKriteriya?.ID || 1, 0.25)
										return (<th className="wrap" style={{ fontWeight: "300" }} key={cidx}>
											<div className="bg bg-grey" style={{ backgroundColor: color }}>
												<	span>{tourCriterion?.tour?.kategoriiUchastnikovNaMeropriyatiyakh?.tantsevalnayaDistsiplina?.nazvanie}, </span>
												<span>{tourCriterion?.tour?.kategoriiUchastnikovNaMeropriyatiyakh?.kategoriyaUchastnikov?.nazvanie}, </span>
												<span>Тур №{tourCriterion?.tour?.number} ({tourCriterion?.tour?.tourType?.name}), </span>
												<span style={{ fontWeight: "bold" }}>
													<span>{tourCriterion?.parametrKriteriya?.criterion?.name}, </span>
													<span>{tourCriterion?.parametrKriteriya?.name}</span>
												</span>
											</div>
										</th>)
									})}
								</tr>
							</thead>
							<tbody style={{ fontSize: "12px" }}>
								{JSXMap(data?.psItogPoMeropriyatiyu || [], (dancerItem, cidx) => {

									return (<tr key={cidx}>
										<td className={`fixed`} style={{ minWidth: "210px", backgroundColor: "white" }}>
											<User user={dancerItem?.tantsor?.user} />
										</td>
										<td className={`fixed`} style={{ left: "210px", minWidth: "100px", maxWidth: "100px", backgroundColor: "white" }}>
											<div className="fixed bg bg-orange dark-1" style={{ fontWeight: "bold" }}>
												{dancerItem?.srednee}
											</div>
										</td>
										<td className={`fixed`} style={{ left: "310px", minWidth: "100px", maxWidth: "100px", backgroundColor: "white" }}>
											<div className="fixed bg bg-orange dark-1" style={{ fontWeight: "bold" }}>
												{dancerItem?.sredneePoDispersiyam}
											</div>
										</td>
										{JSXMap(data?.tourCriterionParams, (tourCriterion, cidx) => {
											let itemCell = data?.esOtsenkiSudey?.find((el) => {
												return el?.tantsor?.userID == dancerItem?.tantsor?.userID &&
													el?.parametrKriteriya?.ID == tourCriterion?.parametrKriteriya?.ID
											})
											let color = getIndexColorLighter(tourCriterion?.parametrKriteriya?.ID || 1, 0.14)
											return (<td className="wrap" style={{ fontWeight: "300" }} key={cidx}>
												<div className="bg bg-grey" style={{ backgroundColor: color }}>
													{itemCell?.otsenkaMinusSredneePoKriteriyu}
												</div>
											</td>)
										})}
									</tr>)
								})}
							</tbody>
						</table>
					</div>
				</div>}
			</Card>
		</div >);
}
